<template>
  <!-- Notes section at the bottom of the appointment Details card (was the "View Notes" action): the appointment's own
       notes, or for no-charge appointments the consumer / order / booking no-charge notes with "add note" -->
  <div class="w-full mt-[20px] pt-[15px] border-t-1 border-[#EFEFEF] font-roboto">
    <span class="block mb-[6px] mobile:text-[14px] laptop:text-[13px] largeDesktop:text-[14px] text-[#EA8A8A]">Notes:</span>

    <div v-if="noCharge" class="flex flex-col max-h-[400px] border-1 border-[#CCCCCC] rounded-[10px] bg-white p-[5px]">
      <ul class="flex-1 overflow-y-auto list-none m-0 p-[5px] flex flex-col gap-[10px]">
        <li v-for="n in notes" :key="n.type + '-' + n.id">
          <div class="rounded-[10px] p-[10px] bg-[#EFEFEF] break-words">
            <p class="m-0 leading-[20px] text-[14px] text-[#333333] whitespace-pre-line">{{ n.notes }}</p>
          </div>
          <p class="m-0 mt-[4px] px-[2px] text-[10px] text-[#999999]">
            {{ [n.sender_name, formatTime(n.created_at)].filter(Boolean).join(' · ') }}
          </p>
        </li>
        <li v-if="!notes.length" class="py-4 text-center text-[12px] text-[#999999]">
          {{ loading ? 'Loading notes…' : 'No notes available' }}
        </li>
      </ul>
      <div class="flex items-center gap-2 h-[40px] mt-[5px] rounded-[10px] bg-white shadow-[0px_0px_20px_0px_#00000026] pl-[10px] pr-[5px]">
        <input v-model="newNote" type="text" maxlength="1000" placeholder="Write your Notes..."
          class="flex-1 min-w-0 border-0 outline-none bg-transparent text-[14px] text-[#333333] placeholder:text-[#666666]"
          @keyup.enter="addNote">
        <button type="button" :disabled="!newNote.trim() || busy" aria-label="Send note"
          class="w-[30px] h-[30px] flex-shrink-0 rounded-[6px] bg-[#EFEFEF] border-0 flex items-center justify-center disabled:opacity-50"
          @click="addNote">
          <i class="fa fa-paper-plane text-[#7695FF]" />
        </button>
      </div>
    </div>

    <p v-else-if="appointment.notes" class="m-0 leading-[22px] mobile:text-[16px] laptop:text-[14px] largeDesktop:text-[16px] text-[#333333] whitespace-pre-line break-words">
      {{ appointment.notes }}
    </p>
    <p v-else class="m-0 text-[14px] text-[#999999]">No notes available</p>
  </div>
</template>

<script>
import moment from "moment";
import { useToast } from "vue-toastification";
import { appointmentApi } from "../../services/appointmentApi";

const toast = useToast();

export default {
  name: "AppointmentNotesSection",
  props: {
    appointment: { type: Object, required: true },
  },
  data() {
    return { notes: [], newNote: "", busy: false, loading: false };
  },
  computed: {
    noCharge() {
      return String(this.appointment.type || "").toLowerCase().includes("no_charge");
    },
  },
  watch: {
    "appointment.id": { immediate: true, handler() { this.load(); } },
  },
  methods: {
    async load() {
      this.notes = [];
      if (!this.noCharge || !this.appointment.id) return;
      this.loading = true;
      const res = await appointmentApi.noChargeNotes(this.appointment.id, { silent: true });
      this.loading = false;
      this.notes = res.ok && Array.isArray(res.body) ? res.body : [];
    },
    async addNote() {
      const text = this.newNote.trim();
      if (!text || this.busy) return;
      this.busy = true;
      const res = await appointmentApi.addNoChargeNote(this.appointment.id, text);
      this.busy = false;
      if (!res.ok) return toast.error(res.message || "Unable to save the note.");
      // the API returns the updated list
      if (Array.isArray(res.body)) this.notes = res.body;
      this.newNote = "";
    },
    formatTime(val) {
      const date = /^\d+$/.test(String(val)) ? moment.unix(Number(val)) : moment(val);
      return val && date.isValid() ? date.format("hh:mm a MM/DD/YYYY") : "";
    },
  },
};
</script>
